import axios, { AxiosResponse } from 'axios';
import Customer from '../models/data/Customer';
import SearchCustomersRequest from '../models/requests/SearchCustomersRequest';
import { createRequestConfig } from './utils';
import { CustContact } from '../models/data/LoginCustomer';

/**
 * 最終需要家一覧を取得する
 * @param url basenameを考慮したURL
 * ```typescript
 * const history = useHistory();
 * const url = history.createHref({ pathname: pathnames.customers });
 * ```
 * @param params 顧客情報検索条件
 * @returns 最終需要家の配列
 */
export function requestCustomers(
  url: string,
  params?: SearchCustomersRequest,
): Promise<AxiosResponse<Customer[]>> {
  const config = createRequestConfig({ params });
  return axios.get<Customer[]>(url, config);
}

/**
 *
 * @param url 担当者連絡先を取得する
 * @param params
 * @returns
 */
export function requestCustContact(
  url: string,
  params?: SearchCustomersRequest,
): Promise<AxiosResponse<CustContact>> {
  const config = createRequestConfig({ params, withCredentials: true });
  return axios.get<CustContact>(url, config);
}
